module.exports = __webpack_public_path__ + "static/media/yt-cooking-fire.051a5d2b.mov";